import { A_BRAND, ANIMALE, CRISBARROS, FABULA, FARM, FARM_ETC, FOXTON, MARIAFILO, OFFPREMIUM } from "./brands";

const FABULA_FARM_BRANDS_DATE = new Date('2026-01-26');

const getBrandsFromIdBrand = (profile, initialDate) => {
    if (profile.marcaFilial) {
        if (profile.marcaFilial === ANIMALE) {
            return [OFFPREMIUM];
        }
        if (profile.marcaFilial === A_BRAND) {
            return [ANIMALE, OFFPREMIUM];
        }
        if (profile.marcaFilial === OFFPREMIUM) {
            return [];
        }
        if (profile.marcaFilial === FARM) {
            return [FABULA, FOXTON,FARM_ETC];
        }
        if (profile.marcaFilial === FABULA) {
            return new Date(initialDate) >= FABULA_FARM_BRANDS_DATE
                ? [FARM, FARM_ETC]
                : [];
        }
        if (profile.marcaFilial === FOXTON) {
            return [];
        }
        if (profile.marcaFilial === CRISBARROS) {
            return [];
        }
        if (profile.marcaFilial === MARIAFILO) {
            return [OFFPREMIUM, MARIAFILO];
        }
        if (profile.marcaFilial === FARM_ETC) {
            return [FARM,FABULA];
        }
        return [ANIMALE, FARM, A_BRAND, FABULA, OFFPREMIUM, FOXTON, CRISBARROS, MARIAFILO, FARM_ETC];
    }
    if (profile.marcaFilialMultimarca) {
        return profile.marcaFilialMultimarca;
    }

    if (profile.id_perfil === 14) {
        return [FARM];
    }
    return [ANIMALE, FARM, A_BRAND, FABULA, OFFPREMIUM, FOXTON, CRISBARROS, MARIAFILO, FARM_ETC];
};
export default getBrandsFromIdBrand;
